const MATH_TOKEN_PATTERN = /\S+/g;
const TRAILING_PUNCTUATION = /([.,;:!?]+)$/;

const shouldWrapMathToken = (token) => {
  if (!token) return false;
  if (token.includes("$")) return false;
  if (/\\[a-zA-Z]+/.test(token)) return true;
  if (/\bsqrt\(/i.test(token)) return true;
  if (token.includes("^")) return true;
  if (/[=<>]/.test(token)) return true;
  if (/[+\-*/]/.test(token) && /\d/.test(token)) return true;
  return false;
};

const convertSqrtParens = (value) => {
  let output = "";
  let index = 0;

  while (index < value.length) {
    if (value.startsWith("\\sqrt(", index)) {
      output += "\\sqrt{";
      index += 6;
      let depth = 1;
      const start = index;
      while (index < value.length) {
        const char = value[index];
        if (char === "(") depth += 1;
        if (char === ")") depth -= 1;
        if (depth === 0) break;
        index += 1;
      }
      if (depth === 0) {
        output += value.slice(start, index) + "}";
        index += 1;
      } else {
        output += "(" + value.slice(start);
        index = value.length;
      }
      continue;
    }
    output += value[index];
    index += 1;
  }

  return output;
};

const normalizeMathToken = (token) => {
  let normalized = token.replace(/(^|[^\\])sqrt\(/gi, "$1\\sqrt(");
  normalized = convertSqrtParens(normalized);
  return normalized;
};

const wrapMathTokens = (segment) => {
  return segment.replace(MATH_TOKEN_PATTERN, (token) => {
    if (!shouldWrapMathToken(token)) return token;
    let suffix = "";
    let core = token;
    const match = core.match(TRAILING_PUNCTUATION);
    if (match) {
      suffix = match[1];
      core = core.slice(0, -suffix.length);
    }
    if (!core) return token;
    const normalized = normalizeMathToken(core);
    return `$${normalized}$${suffix}`;
  });
};

const findDelimiter = (text, index) => {
  if (text.startsWith("$$", index)) return { start: "$$", end: "$$" };
  if (text.startsWith("\\(", index)) return { start: "\\(", end: "\\)" };
  if (text.startsWith("\\[", index)) return { start: "\\[", end: "\\]" };
  if (text.startsWith("$", index)) return { start: "$", end: "$" };
  return null;
};

export const normalizeChatMath = (content) => {
  const text = String(content || "");
  if (!text) return text;

  let output = "";
  let lastIndex = 0;
  let index = 0;

  while (index < text.length) {
    const delimiter = findDelimiter(text, index);
    if (!delimiter) {
      index += 1;
      continue;
    }

    const endIndex = text.indexOf(
      delimiter.end,
      index + delimiter.start.length
    );
    if (endIndex === -1) {
      index += delimiter.start.length;
      continue;
    }

    output += wrapMathTokens(text.slice(lastIndex, index));
    output += text.slice(index, endIndex + delimiter.end.length);
    index = endIndex + delimiter.end.length;
    lastIndex = index;
  }

  output += wrapMathTokens(text.slice(lastIndex));
  return output;
};

export const normalizeMathText = normalizeChatMath;
